import { QuantityModifier } from "../quantityModifier";
import styles from "./style.module.css"

interface ICheckoutItemProps
{
    itemImage: string;
    itemName: string;
    itemPrice: string;
    itemQuantity: string;

}

export const CheckoutItem: React.FC<ICheckoutItemProps> = ({itemImage, itemName, itemPrice, itemQuantity}) => 
{
           return(

            <div className={styles.container}>

                <div className={styles.imageContainer}>
                     <img src={itemImage} alt="cartItemImage" className={styles.image} />
                </div>

                <div className={styles.dtsCont}>
                    {itemName}
                    <div className={styles.qtyModifCont}>
                        <div className={styles.text}>Qty :</div>
                        <QuantityModifier/>
                    </div>

                    <div className={styles.pricetxt}>
                        {itemPrice}
                    </div>
                    
                </div>

            </div>

           )
}